(function () {
  if (window.__jiaAccordionInit) return;
  window.__jiaAccordionInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.accordion-trigger');
    if (!btn) return;
    const content = btn.nextElementSibling;
    if (!content || !content.classList.contains('accordion-content')) return;
    const icon = btn.querySelector('.accordion-icon');
    const isOpen = content.classList.contains('open');

    document.querySelectorAll('.accordion-content').forEach((c) => c.classList.remove('open'));
    document.querySelectorAll('.accordion-icon').forEach((i) => { i.textContent = '+'; });
    document.querySelectorAll('.accordion-trigger').forEach((t) => t.setAttribute('aria-expanded', 'false'));

    if (!isOpen) {
      content.classList.add('open');
      if (icon) icon.textContent = '−';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
})();
